import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useSession(sessionId: string) {
  return useQuery({
    queryKey: ['session', sessionId],
    queryFn: () => api.sessions.get(sessionId),
    enabled: Boolean(sessionId),
  });
}

export function useReplayUrl(sessionId: string, hasReplay: boolean) {
  return useQuery({
    queryKey: ['replay', sessionId],
    queryFn: () => api.sessions.replayUrl(sessionId),
    enabled: Boolean(sessionId) && hasReplay,
  });
}
